import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { AnalyticsRangeContext } from '@services/analytics-services/core';
import { CommonModule } from '@angular/common';
import { AnalyticsTrendWidgetComponent } from '@enginuity/analytics/organisms/analytics-trend-widget/analytics-trend-widget.component';
import { Subject, takeUntil } from 'rxjs';
import { HighChartContainerComponent } from '@enginuity/analytics/organisms/high-chart-container/high-chart-container.component';
import { DashboardPaymentsStore } from 'src/app/dashboard-module/dashboard-payments/dashboard-payments.store';
import { DashboardStore } from 'src/app/dashboard-module/dashboard/dashboard.store';
import { ProcessingState } from '@services/core-services/models';

@Component({
  selector: 'app-dashboard-payments',
  imports: [CommonModule, AnalyticsTrendWidgetComponent, HighChartContainerComponent],
  templateUrl: './dashboard-payments.component.html',
  styleUrl: './dashboard-payments.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DashboardPaymentsStore],
})
export class DashboardPaymentsComponent implements OnDestroy {
  protected paymentAnalytics$ = this.dashboardPaymentsStore.getPaymentAnalytics();
  protected paymentMethodChartOptions$ = this.dashboardPaymentsStore.getPaymentMethodChartOptions();
  protected totalPaymentError$ = this.dashboardPaymentsStore.gettotalPaymentError();
  protected paymentError$ = this.dashboardPaymentsStore.getPaymentError();
  protected refundError$ = this.dashboardPaymentsStore.getRefundError();
  protected context: AnalyticsRangeContext | undefined;
  protected readonly ProcessingState = ProcessingState;

  private destroy$ = new Subject<void>();

  constructor(
    private readonly dashboardStore: DashboardStore,
    private readonly dashboardPaymentsStore: DashboardPaymentsStore
  ) {
    // Subscribe to range context changes just to update the local 'context' variable.
    // Data loading based on context changes is handled automatically within the
    // DashboardPaymentsStore itself when it subscribes to the same range context.
    this.dashboardStore
      .getRangeContext()
      .pipe(takeUntil(this.destroy$))
      .subscribe(context => {
        this.context = context;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
